<template>
<svg
   width="26"
   height="26"
   viewBox="0 0 18 18"
   fill="none"
   version="1.1"
   id="svg1"
   xml:space="preserve"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1"><pattern
       xlink:href="#pattern1"
       preserveAspectRatio="xMidYMid"
       id="pattern2"
       patternTransform="translate(-1.6833718,-1.4578588)" /><pattern
       patternUnits="userSpaceOnUse"
       width="21.453304"
       height="21.453304"
       patternTransform="translate(-1.6833718,-1.4578588)"
       preserveAspectRatio="xMidYMid"
       id="pattern1"><image
         width="21.453304"
         height="21.453304"
         preserveAspectRatio="none"
         xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAABHNCSVQICAgIfAhkiAAAAzNJREFU&#10;WIXt1s9P02AYB/BnYt4CdrNuDraIsbgN3RZDd9BhlB8TyTKESFyC4oXhyZPuP2Dc9CT8BeJF9CCQ&#10;kBCJhyGayBLNCorIr2wYl5R0dj8o4LoDHrAJGd3YRvHE97auffbJ0/d99gIc5Si5UyJXIY1aSzka&#10;XENWi81bVlauY9Yi7/87RKPWUi7nHX9JSUnp1tYmYzKaPQAAhWAODBERgpCKj08MO+bm6QElrqq2&#10;Wigvv5Fc5bgonU+dY3IieD4ZBgD4HWNpAABBEOL51ioakg0BAHDurOE2sxaZXP25MnqokExEWkjF&#10;MYQR4vcIIQK2C6tZ8BrJRCgAoK317idthe5qKLT4CgCgrPyE3mQ0e7hYdCaRiP0AALCaqccVWl0d&#10;G2UCUnWPHxThcrr9CCEiSAd84n1z3+l+k8HS3ey4NcIwkUmEMEKtPk0BACCEEcGZQF9m7bw7kgsx&#10;PjHs4DiWttXae2uMFg8bZQJz8/RAIhlf0Gi01NafTWb22+enaUFIWC2UV0inEizLTO+ur5ALUX+t&#10;5bk4P5ZW5gc/fHzXI1Wro70rCKCA0bGXtt3X912shSIAABjml+QgU+IqEqFSQkin9mzrnJBiEMGZ&#10;QN/S8vygyWDu7mi/H0T/dpMSV5Eup9sPsA1TEt3KCikWEaQDPpPB3F1/vWUQAEAQUvHdiMyZI0Zy&#10;jUgNq053T6gQBMdF6fGJNw4MYcR+CMmOSCEQwgh+Ixk+LIRkR1qdbj+OK8lsD9ovNzyzWiivnAjJ&#10;juC4iuT59XC2BxGGnZIbASA10BSguHjh0kMlriLVai1Vd6Wx/3x1zT2EMCKRjC2wLDMNClCEwouv&#10;Z79+eSIHYudnJWKj7D5brb0XAIBZi0wCAOgqzzTxfDI8OjZkE4SdOSAXImdMRotHr6tqEj/rdVVN&#10;D7ofbdsou0+8dtPRNiLOCiWuIjvdPaFOtyeE4yrywIBc6WjvCjbfaNtzxpADUfB5BEPYyUyEHK8j&#10;b4jJaPao1Vpqafn7C7kRBUHE/wx9ZVWj3AiAPI8BYsTdxHFRGseVpNR5tdgUdFRkmMgkv7G+WlGh&#10;q+NiUdo/9bZLli16lKPkkb8gZm+1W+CPWwAAAABJRU5ErkJggg==&#10;"
         id="image1"
         x="0"
         y="0" /></pattern></defs><rect
     style="display:none;fill:url(#pattern2);stroke:none"
     width="21.453304"
     height="21.453304"
     x="-1.6833718"
     y="-1.4578588"
     id="rect1" /><path
     d="m 14.8239,5.22107 c 0.3043,-0.00961 0.5997,-0.09435 0.8615,-0.24083 l 1.1632,1.13887 c 0.21,0.20593 0.3275,0.49518 0.3171,0.81096 -0.0104,0.31726 -0.15,0.63376 -0.3956,0.87464 L 7.97118,16.4191 C 7.72514,16.6596 7.40186,16.7962 7.07781,16.8065 6.75534,16.8166 6.45997,16.7016 6.24963,16.4962 L 5.08622,15.3571 C 5.23583,15.1009 5.32239,14.8116 5.33221,14.5137 5.34759,14.0469 5.17251,13.5955 4.83562,13.2657 4.49873,12.9359 4.03773,12.7645 3.56091,12.7795 3.2566,12.7892 2.96119,12.8739 2.69941,13.0204 L 1.53599,11.8814 C 1.32617,11.6754 1.20864,11.3863 1.21904,11.0705 1.22949,10.7533 1.36901,10.4369 1.61454,10.196 L 10.4137,1.58136 c 0.2461,-0.24038 0.5693,-0.37697 0.8933,-0.38721 0.3225,-0.01018 0.618,0.10494 0.8283,0.31046 l 1.1633,1.13887 c -0.1497,0.25629 -0.2362,0.54551 -0.246,0.84344 -0.0154,0.46682 0.1597,0.91815 0.4966,1.24798 0.3368,0.32983 0.7978,0.50123 1.2747,0.48617 z"
     fill="currentColor"
     stroke="currentColor" 
     id="path1"
     style="fill:#000000;fill-opacity:0;stroke:currentColor;stroke-opacity:1" /><path
     style="fill:currentColor;fill-opacity:1;stroke:currentColor;stroke-linecap:round;stroke-opacity:1"
     d="M 4.9202734,9.9020506 C 9.8200456,5.0022779 9.8200456,5.0022779 9.8200456,5.0022779"
     id="path2" /><path
     style="fill:currentColor;fill-opacity:1;stroke:currentColor;stroke-linecap:round;stroke-opacity:1"
     d="M 8.2824601,13.161732 C 13.182232,8.261959 13.182232,8.261959 13.182232,8.261959"
     id="path3" /><path
     style="fill:currentColor;fill-opacity:1;stroke:currentColor;stroke-width:1.81578;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
     d="M 6.8577766,11.347236 C 11.306233,6.8987788 11.306233,6.8987788 11.306233,6.8987788"
     id="path4" /></svg>

</template>

<script>
export default {
  name: 'TicketRulesIcon'
}
</script>